import React from 'react';
import Div from './Div';
import Picture from './Picture';
import Heading from './Heading';
import Container from './Container';

const TitleBanner = ({ title, desktopImage, mobileImage }: any) => {
  return (
    <Div className="relative">
      <Picture
        mobile={mobileImage.data.attributes}
        desktop={desktopImage.data.attributes}
        className="w-full"
      />
      <Div className="absolute flex items-center top-0 left-0 right-0 bottom-0">
        <Container>
          <Heading className="text-h-1 text-cti-on-primary" level={1}>
            {title}
          </Heading>
        </Container>
      </Div>
    </Div>
  );
};

export default TitleBanner;
